import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import {Table, PageHeader, Button, Input, message} from 'antd';
import {EyeOutlined, SyncOutlined} from '@/icons';
import styles from '../index.module.less';
import {getRooms, syncRoom, getAllRooms} from '@/api/room';
import RoomMemberModal from './RoomMemberModal';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {getColumns} from '@/page/customer/RoomPage/roomColumns';
import {useEditAuthService} from '@/page/admin/adminService';

// 可以作为组件在继承中使用
const RoomTable = forwardRef(
    ({isComponent = false, owner = {}, selectRooms, roomKeys = []}, ref) => {
        const editable = useEditAuthService(['global:customer_room_mgr:w']);
        const [authStore] = useAuthStore();
        const userId = _.get(authStore, 'user.extId');
        const modalRef = useRef();
        const [current, setCurrent] = useState(1);
        const [size, setSize] = useState(10);
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        const [searchParam, setSearchParam] = useState({
            name: '',
        });
        const [data, setData] = useState([]);
        const [roomInfo, setRoomInfo] = useState({});
        const [loading, setLoading] = useState(false);
        const [selectAll, setSelectAll] = useState(false);
        useImperativeHandle(ref, () => ({
            init,
        }));
        useEffect(() => {
            init();
        }, [current, size]);
        const rowSelection = {
            selectedRowKeys,
            onSelect: onSelect,
            onSelectAll: onSelectAll,
        };
        const extra = (
            <Input.Group compact>
                <Input
                    className={styles.baseSearch}
                    placeholder="请输入群名称"
                    onChange={changeName}
                />
                <Button type="primary" onClick={() => search()}>
                    查询
                </Button>
                {/*<Button*/}
                {/*    type="primary"*/}
                {/*    icon={<SyncOutlined />}*/}
                {/*    style={{marginLeft: '10px'}}*/}
                {/*    onClick={sync}*/}
                {/*    disabled={!editable}*/}
                {/*>*/}
                {/*    同步*/}
                {/*</Button>*/}
            </Input.Group>
        );
        let columns = getColumns(['name', 'ownerName', 'ownerType', 'notice']);
        columns.push({
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            render: (text, record) => (
                <Button
                    style={{color: '#152D85'}}
                    type="text"
                    icon={<EyeOutlined />}
                    onClick={() => {
                        showDetail(record);
                    }}
                >
                    查看详情
                </Button>
            ),
        });

        function init(isReload = false) {
            isReload && setSelectAll(false);
            setSelectedRowKeys(roomKeys);
            setLoading(true);
            let {name} = searchParam;
            let param = {
                name: name,
                current,
                size,
                extId: isComponent ? owner.extId : userId,
                isComponent,
            };
            getRooms(param).then(res => {
                let result = res.data;
                if (isComponent && res.data.records.length > 0)
                    result.records = res.data.records.filter(v => v.ownerName == owner.name);
                setData(res.data);
                setLoading(false);
            });
        }

        function onSelect(record, selected) {
            let temp = [...selectedRowKeys];
            let select;
            if (selected) {
                temp.push(record.chatId);
                select = [...temp];
            } else select = temp.filter(item => item != record.chatId);
            setSelectedRowKeys(select);
            selectRooms(!(select.length > 0), select);
        }

        function onSelectAll() {
            // 后台查询所有数据，并更新进rowkeys
            if (!selectAll) {
                getAllRooms(isComponent ? owner.extId : userId).then(res => {
                    let select = [];
                    if (res.data.length > 0) {
                        res.data.forEach(record => select.push(record.chatId));
                        setSelectedRowKeys([...select]);
                        selectRooms(false, select);
                    }
                });
            } else {
                setSelectedRowKeys([]);
                selectRooms(true, []);
            }
            setSelectAll(!selectAll);
        }

        function changeName(e) {
            let param = {...searchParam};
            param.name = e.target.value;
            setSearchParam(param);
        }

        function search() {
            setCurrent(1);
            init();
        }

        function sync() {
            setLoading(true);
            syncRoom(userId).then(res => {
                setLoading(false);
                message.success('同步成功');
                init(1);
            });
        }

        function showDetail(record) {
            setRoomInfo(record);
            setTimeout(() => {
                modalRef.current.open();
            }, 200);
        }

        function onShowSizeChange(current, pageSize) {
            setSize(pageSize);
            setCurrent(current);
        }

        function onChange(pageNumber) {
            setCurrent(pageNumber);
        }

        return (
            <div>
                <div className={styles.header}>
                    <PageHeader title="客户群列表" extra={isComponent || extra} />
                </div>
                <Table
                    className={styles.tableContainer}
                    loading={loading}
                    rowSelection={isComponent && rowSelection}
                    columns={columns}
                    dataSource={data.records}
                    rowKey={record => record.chatId}
                    pagination={{
                        total: data.total,
                        showTotal: total => `共 ${total} 条记录`,
                        showSizeChanger: true,
                        onShowSizeChange: onShowSizeChange,
                        onChange: onChange,
                        current,
                        pageSize: size,
                    }}
                />
                <RoomMemberModal ref={modalRef} roomInfo={roomInfo} selectRooms={selectRooms} />
            </div>
        );
    }
);

RoomTable.displayName = 'RoomTable';

RoomTable.prototype = {
    // 是不是作为组件
    isComponent: PropTypes.bool,
    // 群主信息
    owner: PropTypes.object,
};

export default RoomTable;
